import type { QuizResult } from '@mentimeter/quiz-types';
import { usePreviewResultsIterator } from '@mentimeter/slides-preview-results';
import { useCallback } from 'react';

interface UseQuizChoicesPreviewResultsProps {
  isPreviewResultsEnabled: boolean;
  choices: Array<{
    id: number;
    label: string;
  }>;
}
const SCORE_MIN = 0;
const SCORE_MAX = 100;

export const useQuizChoicesPreviewResultsLegacy = ({
  isPreviewResultsEnabled,
  choices,
}: UseQuizChoicesPreviewResultsProps) => {
  const getNextResults = useCallback(
    (iteration: number, _: any) => {
      if (iteration % 2 === 0) {
        const getRandomScore = () =>
          Math.floor(Math.random() * (SCORE_MAX - SCORE_MIN + 1)) + SCORE_MIN;
        return [
          ...choices.map((choice) => ({
            question_id: '',
            choice_id: choice.id,
            responses: getRandomScore(),
          })),
        ];
      } else {
        return [];
      }
    },
    [choices],
  );

  const getIntervalChoices = useCallback((iteration: number) => {
    if (iteration === 1) {
      return 300;
    }
    if (iteration % 2 === 0) {
      return 3000;
    } else {
      return 1500;
    }
  }, []);

  return (
    usePreviewResultsIterator<QuizResult[]>(
      isPreviewResultsEnabled,
      getNextResults,
      getIntervalChoices,
    ) ?? []
  );
};
